import React from 'react';

import { ToggleField } from '@dndbeyond/character-common-components/es';

import { SidebarSubheading } from '../../../../components/Sidebar';

interface Props {
    initiallyEnabled: boolean;
    onChange: (isEnabled: boolean) => void;
    heading: React.ReactNode;
    description: string;
}
export default class PreferencesPaneToggleField extends React.PureComponent<Props> {
    static defaultProps = {
        initiallyEnabled: false,
    };

    render() {
        const { heading, description, initiallyEnabled, onChange } = this.props;

        return (
            <div className="ct-preferences-pane__field ct-preferences-pane__field--toggle">
                <div className="ct-preferences-pane__field-heading-input">
                    <SidebarSubheading className="ct-preferences-pane__field-heading">
                        {heading}
                        <ToggleField label={description} initiallyEnabled={initiallyEnabled} onChange={onChange} />
                    </SidebarSubheading>
                </div>
                <div className="ct-preferences-pane__field-summary">
                    {description && <div className="ct-preferences-pane__field-description">{description}</div>}
                </div>
            </div>
        );
    }
}
